<template>
  <div class="contactUs-wrapper">
    <div class="contactUs">
      <div class="contactUs_text">
        <p class="contactUs_text-question">Need Access?</p>
        <p class="contactUs_text-title">Contact Us!</p>
      </div>
      <form class="contactUs_form">
        <div class="contactUs_form_col">
          <label for="name" class=contactUs_form-label>Name</label>
          <input type="text" name="name" placeholder="Write your name" class="contactUs_form-input" v-model="name"  :class="wrongName ? 'contactUs_form-input-wrong' : ''">
        </div>
        <div class="contactUs_form_col">
          <label for="message" class=contactUs_form-label>Message</label>
          <input type="text" name="message" placeholder="Write your message" class="contactUs_form-input" v-model="message"  :class="wrongMessage ? 'contactUs_form-input-wrong' : ''">
        </div>
        <div class="contactUs_form_col">
          <label for="email" class=contactUs_form-label>Email</label>
          <div class="contactUs_form_row">
            <input type="text" name="email" class="contactUs_form-input" placeholder="Write your email"  v-model="email" :class="wrongEmail ? 'contactUs_form-input-wrong' : ''">
            <button type="button" class="contactUs_form-button" @click="contactUs()">
              <img src="@/assets/svg/arrow.svg">
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import EmailServices from "../../services/EmailServices";
export default {
  data() {
    return {
      name: '',
      email: '',
      message: '',
      wrongName: false,
      wrongEmail: false,
      wrongMessage: false
    }
  },
  methods: {
    async contact() {
      try{
        const response = await EmailServices.contactUs(this.name, this.email, this.message);
        return response;
      }
      catch (errors) {
        console.log(errors)
        return errors;
      }
    },
    contactUs() {

      if(this.name == '') {
        this.wrongName = true
      }
      else {
        this.wrongName = false
      }
      if(this.email == '') {
        this.wrongEmail = true
      }
      else {
        this.wrongEmail = false
      }
      if(this.message == '') {
        this.wrongMessage = true
      }
      else {
        this.wrongMessage = false
      }
      if(this.name!=='' && this.email!='' && this.message!='') {
        this.contact().then((response)=>{
        console.log(response)
        this.name = ''
        this.email = ''
        this.message = ''
      })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contactUs {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 20px;
  @media screen and (max-width: 600px) {
      flex-direction: column;
      padding-left: 15px;
    }
  &-wrapper {
    width: 100%;
    background-color: #1a924a;
    padding:56px 0;
  }
  &_text {
    display: flex;
    flex-direction: column;
    width:30%;
    @media screen and (max-width: 600px) {
      padding-left: 0;
    }
    &-question {
      color: #e4e4e4;
      font-family: "Gotham Pro";
      font-size: 14px;
      font-weight: 400;
      line-height: 48px;
      letter-spacing: 0.7px;
      margin:0;
      @media screen and (max-width: 600px) {
        margin-bottom: 31px;
      }
    }
    &-title {
      color: #ffffff;
      font-family: "Optimal C";
      font-size: 24px;
      font-weight: 400;
      line-height: 36px;
      letter-spacing: 1.2px;
      margin:0;
      @media screen and (max-width: 600px) {
        margin-bottom: 33px;
      }
    }
  }
  &_form {
    display:flex;
    flex-direction:row;
    width:70%;
    justify-content: space-between;
    @media screen and (max-width: 600px) {
      flex-direction: column;
      width:100%;
    }
    &_col {
      display: flex;
      flex-direction: column;
      width:30%;
      @media screen and (max-width: 600px) {
        width:100%;
      }
    }
    &_row {
      display: flex;
      flex-direction: row;
    }
    &-label {
      color: #ffffff;
      font-family: "Optimal C";
      font-size: 15px;
      font-weight: 400;
      line-height: 36px;
      letter-spacing: 0.75px;
    }
    &-input {
      border:none;
      border-bottom: 1px solid #e4e4e4;
      outline: none;
      background-color: transparent;
      height:45px;
      color: #e4e4e4;
      width:100%;
      &::placeholder {
        opacity: 0.75;
        color: #e4e4e4;
        font-family: "Gotham Pro";
        font-size: 14px;
        font-weight: 300;
        font-style: italic;
        line-height: 48px;
        letter-spacing: 0.7px;
      }
      &-wrong {
        border-bottom: 1px solid red;
      }
    }
    &-button {
      width: 56px;
      height: 48px;
      background-color: #ffffff;
      outline:none;
      border:none;
      cursor:pointer;
      img {
        width:13px;
        height: 9px;
      }
    }
  }
}
</style>